import { Turn } from '../interfaces';

export const CodePerShift: Array<Turn> = [
  {
    idTurno: 1, label: 'Manhã', check: false, limiteAgendamentosTurnoPorUsuario: null,
  },
  {
    idTurno: 2, label: 'Tarde', check: false, limiteAgendamentosTurnoPorUsuario: null,
  },
  {
    idTurno: 3, label: 'Noite', check: false, limiteAgendamentosTurnoPorUsuario: null,
  },

];
